import React, {useState} from 'react';
import {Modal} from "antd";
import ImgClose from "@/shared/pictures/close.svg";
import ImgStartPack from "@/shared/pictures/start_pack.png";
import {EmailInput} from "@/shared/ui/EmailInput";
import {useStore} from "@/app/providers/StoreProvider";
import {buyInventoryItem} from "@/shared/api/api";
import {InventoryItemsName} from "@/entities/inventory/types";


export const StartPackModal = () => {
    const { modalStore, errorStore } = useStore();

    const [email, setEmail] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);


    const buyItem = async () => {
        if (!isEmailValid) return;

        const buyResponse = await buyInventoryItem(InventoryItemsName.StartPack, 1, email);
        if (buyResponse.success) {
            window.location.href = buyResponse.data.paymentUrl;
        } else {
            errorStore.setError(buyResponse.error);
        }
    }

    return (
        <Modal
            open={true}
            footer={null}
            closeIcon={<img src={ImgClose} onClick={() => modalStore.close()} alt=""/>}
        >
            <div className='modal'>

                <img src={ImgStartPack} className='modal_image'
                     alt="" style={{maxWidth: 100}}/>

                <h3 className='modal_title'>У вас есть возможность сейчас приобрести со скидкой стартовый пакет с инвентарем</h3>
                <p className='modal_text'>Скидка сгорит через 12 часов!</p>

                <EmailInput
                    value={email}
                    onChange={(val, isValid) => {
                        setEmail(val);
                        setIsEmailValid(isValid);
                    }}
                />

                <div className='modal_buttons'>
                    <button type='button' className='modal_button button_blue' onClick={() => buyItem()}>Купить
                    </button>
                    <p className='modal_text-policy'>Нажимая "Купить" - вы соглашаетесь <br/>с <a
                        href='https://docs.google.com/document/d/169Rsrf_Rw7mLgFuM-8C4LHNrs57pVMgahcAC7FL2lyc'>публичной
                        офертой</a>
                    </p>
                    <button type='button' className='modal_button button_gray'
                            onClick={() => modalStore.close()}>Закрыть
                    </button>
                </div>

            </div>
        </Modal>
    );
};

